<template>
  <div class="member">
    <div calss="coordinates">
      <img src="../assets/member/hhd_vip_01.jpg" calss="vip_img">
      <div class="openVip">
        <img src="../assets/member/hhd_vip_02.jpg">
        <div class="openVipWin">
          <span class="preferential">
            限时特惠:
            <span class="years_money">¥ {{vipPriceList.vipPrice}}/{{vipPriceList.deadline}}年</span> 立即开通
          </span>
          <img src="../assets/member/vip_wkt_jump.png">
        </div>
      </div>
      <div class="full_discount">
        <img src="../assets/member/hhd_vip_03.jpg">
        <div class="tab" ref="tab">
          <ul class="tab_content" ref="tabWrapper">
            <li class="tab_item" ref="tabitem" v-for="item in itemTab" :key="item.title">
              <img :src="item.resource" class="tab_img">
            </li>
          </ul>
        </div>
      </div>
      <img src="../assets/member/hhd_vip_04.jpg">
      <img src="../assets/member/hhd_vip_05.jpg">
      <!-- <div class="addVip">
                <img src="../assets/member/hhd_vip_06.jpg">
                <img src="../assets/member/vip_btn.jpg" class="add_img">
      </div>-->
    </div>
  </div>
</template>

<script>
/* eslint-disable semi */
// eslint-disable-next-line no-unused-vars
/* eslint-disable */

import { recommendImg, findVipPriceList } from "@/request/api";
import BScroll from "better-scroll";
export default {
  data() {
    return {
      itemTab: [],
      vipPriceList: []
    };
  },
  created() {
    this.getRecommendImg();
    this.getFindVipPriceList();
  },
  methods: {
    personScroll() {
      let width = 0;
      for (let i = 0; i < this.itemTab.length; i++) {
        width += this.$refs.tabitem[0].getBoundingClientRect().width; // getBoundingClientRect() 返回元素的大小及其相对于视口的位置
      }
      // this.$nextTick 是一个异步函数，为了确保 DOM 已经渲染
      this.$refs.tabWrapper.style.width = width + "px";
      this.$nextTick(() => {
        if (!this.scroll) {
          this.scroll = new BScroll(this.$refs.tab, {
            startX: 0,
            click: true,
            scrollX: true,
            scrollY: false,
            eventPassthrough: "vertical"
          });
        } else {
          this.scroll.refresh();
        }
      });
    },
    // 非会员页面的商品图片
    getRecommendImg() {
      recommendImg({})
        .then(res => {
          this.itemTab = res.result;
          this.$nextTick(() => {
            this.personScroll();
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 开通会员以及续费接口
    getFindVipPriceList() {
      findVipPriceList({})
        .then(res => {
          this.vipPriceList = res.result.priceList[0];
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped>
@import "../assets/css/function.scss";
.member {
  font-size: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  img {
    width: 100%;
  }
  .openVip {
    position: relative;
    .openVipWin {
      height: px2rem(98px);
      background: linear-gradient(
        0deg,
        rgba(193, 153, 49, 1) 0%,
        rgba(234, 205, 130, 1) 100%
      );
      position: absolute;
      left: 0px;
      right: 0px;
      line-height: px2rem(98px);
      margin: 0 px2rem(63px);
      border-radius: 45px;
      text-align: center;
      bottom: 0px;
      font-size: px2rem(34px);
      img {
        width: px2rem(34px);
        height: px2rem(30px);
      }
      .preferential {
        font-family: PingFangSC-Light;
        font-weight: 300;
        color: rgba(255, 255, 255, 1);
      }
      .years_money {
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
      }
    }
  }
  .full_discount {
    position: relative;
    .tab {
      position: absolute;
      width: 100vw;
      overflow: hidden;
      bottom: 0;
      .tab_content {
        display: flex;
        .tab_item {
          flex: 0 0 px2rem(10px);
          .tab_img {
            width: px2rem(230px);
            height: px2rem(298px);
            margin-left: px2rem(30px);
            border-radius: px2rem(14px);
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue